import React from "react";
import MetricsCardValue from '@/pages/dashboard/components/MetricsCardValue';
import MetricsCardDod from '@/pages/dashboard/components/MetricsCardDod';
import IconTips from '@sg/components/IconTips';
import DefinitionBubble from '@sg/components/DefinitionBubble';
import info from '@sg/assests/svg/info.svg';
import {IMetricsCardWithRank} from './type';
import { useIntl } from 'umi';

interface IMetricsCardProps {
  data: IMetricsCardWithRank;
  showTitle?: boolean;
  metricKey?: string; // Add metricKey to identify the card type
};

export default function MetricsCardWithRank(props: IMetricsCardProps) {
  const { formatMessage, locale } = useIntl();
  const { showTitle = true, metricKey } = props;
  const {
    className: childClassName,
    valueStyle: childValueStyle,
    dodData: childDodData,
    formatRule: childFormatRule,
    emptyValue: childEmptyValue,
    preUnit: childPreUnit,
    endUnit: childEndUnit,
    titleEn: childTitleEn,
    titleCn: childTitleCn,
    value: childValue,
    dodClassName: childDodClassName,
    dodStyle: childDodStyle,
    isIconTips,
    tipsEn: tips,
    definition,
    source,
    updateTime,
    // tipsCn: tipsCn,
  } = props?.data || {};
  // Select the correct text based on locale
  const isZh = locale === 'zh-CN';
  const title = isZh ? childTitleCn : childTitleEn;
  // const tips = isZh ? childTipsCn : childTipsEn;
  const hasDefinitionInfo = !!(definition || source || updateTime);

  const hasValue = !!parseInt(String(childValue));

  return (
    <div
      className={`dbd-metrics-card-with-rank__metrics-card ${hasValue ? '' : 'dbd-metrics-card-with-rank__metrics-card--empty'}`}
    >
      {/* making its boolean */}
      {showTitle && (
        <div className='dbd-metrics-card-with-rank__metrics-card__title'>
          <div
            className='dbd-metrics-card-with-rank__metrics-card__title__text'
            style={{ fontSize: props.data?.metricType === 'split' ? '18px' : '22px'}}
          >{title}</div>
          {isIconTips && (
            hasDefinitionInfo ? (
              <DefinitionBubble
                definition={definition}
                source={source}
                updateTime={updateTime}
                style={{ maxWidth: '450px' }}
              >
                <div className="dbs-icon-tips-icon dbd-metrics-card-with-rank__metrics-card__title__tips-info">
                  <div className="dbs-icon-tips-wrapper" style={{ width: '16px', height: '16px' }}>
                    <img
                      src={info}
                      alt="info"
                      className="dbs-icon-tips-icon-svg"
                      style={{ width: '16px', height: '16px' }}
                    />
                  </div>
                </div>
              </DefinitionBubble>
            ) : (
              <IconTips
                tipString={tips}
                className='dbd-metrics-card-with-rank__metrics-card__title__tips-info'
                mWidth="450px"
              />
            )
          )}
        </div>
      )}
      {hasValue ? <>
        <MetricsCardValue 
        className={childClassName}
        style={childValueStyle}
        value={childValue}
        formatRule={childFormatRule}
        emptyValue={childEmptyValue}
        preUnit={childPreUnit}
        endUnit={childEndUnit}
      />
      <MetricsCardDod 
        className={childDodClassName}
        style={childDodStyle}
        data={childDodData}
      />
      </> :
      <div
        style={{
          width: '100%',
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          // padding: '6px 0',
        }}
      >
        {/* Use special message for Unit Sales card and its children (Base Sales, DLC Sales), default message for others */}
        {(metricKey === 'unit_sales' || metricKey === 'base_sales' || metricKey === 'dlc_sales')
          ? formatMessage({ id: 'dbs_empty_text_unit_sales' })
          : formatMessage({ id: 'dbs_empty_text' })
        }
      </div>
      }
    </div>
);
}